import { ProjectTitle } from './StartProjectTitle.styled';

const StartProjectTitle = () => {
  return (
    <ProjectTitle>
      Start Your <span>Project</span>
    </ProjectTitle>
  );
};

export default StartProjectTitle;
